import { Button } from 'antd5';

export const BlueButton = ({ className, onClick, children, }) => {
    return (
        <Button size="large" onClick={onClick} className={`${className} oxygen-regular`}>{children}</Button>
    )
}

export default BlueButton